<template>
    <tr :class="{onDelete: isOnDelete}">
        <!-- <td>
            <TableSelectCheckbox :checkboxId=" 'select_' + evaluation.id" @change="checkSelectedEval" :isChecked="isSelected" />
        </td> -->

        <td>
            <div class="candidate_name">
                <completedMark :evaluation="evaluation" />
                <div>
                    <router-link :to=" 'evaluations/' + evaluation.id ">
                        <span class="cand_name">{{ evaluation.candidate_username }}</span>
                    </router-link>
                    <div>
                        <span class="cand_name">{{ evaluation.candidate_email }}</span>
                    </div>
                    <div class="associated_recruiter_name" v-if="notOwnedEval">
                        <span>{{ evaluation.recruiter_name }}</span>
                    </div>
                </div>
            </div>
        </td>

        <td>
            <div class="ref_name">{{ getRefName(evaluation.saven_test.sight_ref) }}</div>
        </td>

        <td>
            <div v-if="evaluation.completed">
                <div class="reports_dropdown edit_action_button" v-if="!evaluation.in_regen">

                    <ReportsDropDown
                        :doc_files="evaluation.docs_ids"
                        :expert_report_url="evaluation.saven_test.expert_report_url"
                        :candidate_report_url="evaluation.saven_test.candidate_report_url"
                        :manager_report_url="evaluation.saven_test.manager_report_url"
                        :customer_report_url="evaluation.saven_test.customer_report_url"
                        @deleteFileClicked="deleteFileFromEval"/>
                </div>
                <div class="edit_action_button" v-else>
                    <ReportsInGen/>
                </div>
            </div>

            <div v-if="!evaluation.completed && !notOwnedEval">
                <a class="resend_button is-outlined is-info table-button" @click="resendEmail">
                    <IconMail/> {{ $t('modules.evaluations.index.evalsList.resendEvalButton') }}
                </a>
            </div>
        </td>

        <td>{{ createdAt }}</td>

        <td class="icon_td is-cursor " >
            <TableDeleteButton @confirmClicked="deleteEval" v-if="!notOwnedEval" />
            <div v-else>-</div>
        </td>
    </tr>
</template>

<script>
import ReportsDropDown from './reportsDropDown'
import ReportsInGen from './ReportsInGen'


export default {
    name: 'TableEvalsRow',
    props: ['evaluation', 'index'],
    components: {
        ReportsDropDown,
        ReportsInGen
    },
    mounted(){
        this.checkReportsRegen()
    },
    data(){
        return {
            isOnDelete: false,
            intervalId: "",
            userData: JSON.parse(localStorage.getItem('account')).user,
        }
    },
    computed: {
        createdAt(){
            return this.$date(this.evaluation.created_at, "YYYY-MM-DD HH:mm:ss").locale(this.$i18n.locale).fromNow()
        },
        notOwnedEval(){
            return this.userData.id != this.evaluation.user_id
        },
        isSelected(){
            return this.$store.state.EvalStore.selectedEvals.includes(this.evaluation.id)
        }
    },
    methods: {
        getRefName(refItem){
            if (refItem.ref_type == 'saven'){
                return this.$i18n.t("refs.jobs." + refItem.slug)
            }else{
                return refItem.name
            }
        },
        resendEmail(){
            this.$store.dispatch('EvalStore/resendEmail', this.evaluation).then(() => {
                this.$emit('notifSended')
            })
        },
        deleteEval(){
            this.isOnDelete = true
            this.$store.dispatch('EvalStore/deleteEval', this.evaluation).then(() => {
                this.$store.dispatch('EvalStore/indexEvals')
                this.$emit('evaluationDeleted')
            })
        },
        checkReportsRegen(){
            this.intervalId = setInterval(() => {
                if (this.evaluation){
                    if (this.evaluation.in_regen){
                        this.$store.dispatch('EvalStore/indexEvals', {})
                    }
                }
            }, 5000)
        },
        deleteFileFromEval(file){
            const evalFiles = JSON.parse(JSON.stringify(this.evaluation.docs_ids))
            this._.remove(evalFiles, function(evalFile){
                return evalFile.file_id == file.file_id
            });
            this.$store.dispatch('EvalStore/saveEval', {id: this.evaluation.id, docs_ids: evalFiles})
        },
        checkSelectedEval(isChecked){
            console.log(isChecked)
            if (isChecked){
                this.$store.dispatch('EvalStore/addEvalToSelection', this.evaluation.id)
            }else{
                this.$store.dispatch('EvalStore/removeEvalFromSelection', this.evaluation.id)
            }

        }

    },
    beforeDestroy () {
        clearInterval(this.intervalId)
    }
}
</script>

<style lang="scss">
#evaluations_table{
    .dl_doc_button{
        display: flex;
        align-items: center;
        padding: 0 12px;
        svg{
            fill: $info;
            width: 22px;
            margin-right: 8px;
        }
        &:hover{
            svg{ fill: $white; }
        }
    }
    .resend_button{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: $info;
        text-transform: uppercase;
        svg{
            fill: $info;
            width: 22px;
            margin-right: 8px;
        }
    }
    .candidate_name{
        display: flex;
        align-items: center;
        .cand_name{
            display: inline-block;
            padding-left: 28px;
            font-weight: 600;
        }
    }
    .ref_name{
        margin-top: 8px;
        text-transform: uppercase;
        font-weight: 500;
        color: $grey-light;
        font-size: .85rem
    }
    .associated_recruiter_name{
        font-style: italic;
        font-weight: 500;
        color: #b5b5b5;
        padding-left: 28px;
        color: $primary;
    }
}
</style>